import type { ReactElement } from 'react';
import React from 'react';
import Icon from 'atom-components/icon';
import Table from 'atom-components/table-lite/table';
import type { AllocationResults } from 'pages/marking/subpages/marking-allocation-tab/types';
import friendlyFailureReason from './friendly-failure-reason';

type Props = {
  allocationResults: AllocationResults;
};

export default function UnallocatedMarkersTable({ allocationResults }: Props): ReactElement {
  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Header />
          <Table.Header>Response ID</Table.Header>
          <Table.Header>Username</Table.Header>
          <Table.Header>Name</Table.Header>
          <Table.Header>Failure Reason</Table.Header>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {allocationResults.unallocatedMarkers.map((marker) => (
          <Table.Row key={`${marker.responseId}-${marker.organisationUserId}`}>
            <Table.DataCell>
              <Icon icon="xmark" />
            </Table.DataCell>
            <Table.DataCell>{marker.responseId}</Table.DataCell>
            <Table.DataCell>{marker.username}</Table.DataCell>
            <Table.DataCell>{marker.name}</Table.DataCell>
            <Table.DataCell>{friendlyFailureReason(marker)}</Table.DataCell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}
